import { createAction, props } from "@ngrx/store"
import { AuthorizerDto } from "./authorizers.dtos"

export const fetchMerchantAuthorizers = createAction(
    '[Authorizers module] READ: fetch merchant authorizers'
)

export const fetchMerchantAuthorizersSuccess = createAction(
    '[Authorizers module] STATUS(read): fetch merchant authorizers success',
    props<{authorizers}>()
)

export const fetchMerchantAuthorizersFailed = createAction(
    '[Authorizers module] STATUS(read): fetch merchant authorizers failed'
)




export const createAuthorizer = createAction(
    '[Authorizers module] READ: create authorizer',
    props<{authorizerDto: AuthorizerDto}>()
)

export const createAuthorizerSuccess = createAction(
    '[Authorizers module] STATUS(read): create authorizer success',
    
)

export const createAuthorizerFailed = createAction(
    '[Authorizers module] STATUS(read): create authorizer failed'
)


export const deleteAuthorizer = createAction(
    '[Authorizers module] READ: delete authorizer',
    props<{authorizerID: string}>()
)

export const deleteAuthorizerSuccess = createAction(
    '[Authorizers module] STATUS(read): delete authorizer success',
    
)

export const deleteAuthorizerFailed = createAction(
    '[Authorizers module] STATUS(read): delete authorizer failed'
)